import * as firebase from 'firebase/app';
import DocumentReference = firebase.firestore.DocumentReference;
import {baseClass, HaversineFomula, Lookup} from '@/store/types';
import * as luxon from 'luxon';
import {FirebaseError, User} from 'firebase';
import Vue from 'vue';
import DocumentData = firebase.firestore.DocumentData;
import GeoPoint = firebase.firestore.GeoPoint;
import {DateTime} from 'luxon';
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import * as _ from 'lodash';

// TODO: fix this file so these rules don't need to be disabled
/* tslint:disable:max-classes-per-file */
/* tslint:disable:class-name */
/* tslint:disable:variable-name */
/* tslint:disable:no-bitwise */
/* tslint:disable:no-console */

export interface UserState {
    self: MAFUser | undefined;
    selfRef: DocumentReference | undefined;
    otherdiagnosis: Lookup | undefined;
    diagnosis: Lookup | undefined;
    userType: Lookup | undefined;
    funStuff: Lookup | undefined;
    groupFunStuff: Lookup | undefined;
    distance: Lookup | undefined;
    transactions: UserTransaction[] | undefined;
    purchases: Purchase[] | undefined;
    isBanned: boolean | undefined;
}


export class Purchase {
    public cost: number;
    public what: string;
    constructor(payload: Purchase | DocumentData | null | undefined) {
        this.cost = 0;
        this.what = '';
        if (payload) {
            this.cost = payload.cost;
            this.what = payload.what;
        }
    }
}

export class UserTransaction {
    public static getListOfUserTransaction(payload: UserTransaction[] | QuerySnapshot | undefined): UserTransaction[] {
        if (!payload) {
            return [];
        }
        const ret: UserTransaction[] = [];
        if (payload instanceof QuerySnapshot) {
            payload.forEach((doc) => {
                ret.push(new UserTransaction(doc.data()));
            });
            return ret;
        }
        return payload;
    }
    public transactionTime: Date | string | undefined;
    public purchase: Purchase;
    constructor(payload: UserTransaction | DocumentData | null | undefined) {
        this.purchase = new Purchase(null);
        if (payload) {
            this.purchase = new Purchase(payload.purchase);
            // TODO: fix this IF chaining - not a supportable chunk of code
            this.transactionTime = payload.transactionTime ?
                typeof payload.transactionTime === 'string' ?
                luxon.DateTime.fromISO(payload.transactionTime).toJSDate() : payload.transactionTime instanceof Date
                ? payload.transactionTime : payload.transactionTime.toDate() : undefined;
        }
    }
    public toPlainObject() {
        return JSON.parse(JSON.stringify(this));
    }
}

export class Purchases {
    public values: Purchase[];
    constructor(payload: Purchases | DocumentData| undefined) {
        this.values = [];
        if (payload) {
            payload.values.forEach((pc: any) => {
                this.values.push(new Purchase(pc));
            });
        }
    }
}
export interface mafUser {
    userUploadedImage: boolean;
    uid: string | undefined;
    email: string | undefined;
    signUpPhase: number | undefined;
    name: string | undefined;
    birthdate: Date | string | undefined;
    loBirthdate: Date|string|undefined;
    zipCode: string | undefined;
    otherdiagnosis: string | undefined;
    loOtherDiagnosis: string|undefined;
    diagnosis: string | undefined;
    userType: string | undefined;
    severity: number | undefined;
    interests: string[] | undefined;
    groupInterests: string[] | undefined;
    travelDistance: number | undefined;
    avataarUrl: string | undefined;
    isBanned: boolean| undefined;
    website: string | undefined;
    verifiedCode: boolean | undefined;
    // verified: boolean;
    gender: string | undefined;
    imageURL: string|undefined;
    location: GeoPoint | undefined;
    age: string | undefined;
    geohash: string | undefined;
    termsAgreedOn: Date | string | undefined;
    coins: number;
    lastLogin: Date | string | undefined;
    Reference: DocumentReference | undefined;
    loGender: string |undefined;
    loAge: string|undefined;
    loDiagnosis: string|undefined;
    safetyTraining: boolean|undefined;
    covidTips: boolean | false;
    newMobile: boolean | false;
}

export class MAFUser extends baseClass implements mafUser {

    get formattedCoins(): string {
        return this.coins.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    public termsAgreedOn: Date | string | undefined;
    public lastLogin: Date | string | undefined;
    // public verified: boolean;
    public uid: string | undefined;
    public geohash: string | undefined;
    public userUploadedImage: boolean;
    public coins: number;

    // document reference for updating the user
    public Reference: DocumentReference | undefined;

    public comparison: Comparer | undefined;
    public age: string | undefined;
    public loAge: string |undefined;
    public imageURL: string|undefined;
    public gender: string | undefined;
    public loGender: string|undefined;
    public avataarUrl: string | undefined;
    public birthdate: Date | string | undefined;
    public loBirthdate: Date | string| undefined;
    public email: string | undefined;
    public name: string | undefined;
    public signUpPhase: number | undefined;
    public zipCode: string | undefined;
    public otherdiagnosis: string | undefined;
    public loOtherDiagnosis: string|undefined;
    public diagnosis: string | undefined;
    public loDiagnosis: string|undefined;
    public severity: number | undefined;
    public userType: string | undefined;
    public interests: string[] | undefined;
    public groupInterests: string[] | undefined;
    public travelDistance: number | undefined;
    public location: GeoPoint | undefined;
    public website: string | undefined;
    public verifiedCode: boolean = false;

    public isAdmin: boolean = false;
    public first500: boolean = false;
    public isBanned: boolean = false;
    public blocked: string[] = [];
    public blockingMe: string[] = [];
    public phoneNumber: string | undefined;
    public cellProvider: string | undefined;
    public safetyTraining: boolean|undefined;
    public covidTips: boolean = false;
    public newMobile: boolean = false;

    constructor(payload: MAFUser | DocumentData | undefined) {
        super();
        this.coins = 0;
        this.userUploadedImage = false;
        if (payload) {
            this.coins = payload.coins ? payload.coins : 0;
            this.uid = payload.uid;
            this.userUploadedImage = !!payload.userUploadedImage;
            this.signUpPhase = payload.signUpPhase;
            this.groupInterests = payload.groupInterests;
            this.email = payload.email;

            this.isAdmin = (payload.isAdmin);
            this.isBanned = payload.isBanned;
            this.first500 = (payload.first500);
            this.verifiedCode = payload.verifiedCode;

            this.blocked = payload.blocked || [];
            this.blockingMe = payload.blockingMe || [];
            this.phoneNumber = payload.phoneNumber || '';
            this.cellProvider = payload.cellProvider || '';
            this.safetyTraining = payload.safetyTraining;
            this.covidTips = payload.covidTips;
            this.website = payload.website || '';
            this.newMobile = payload.newMobile || false;

            // @ts-ignore
            // TODO: fix these if chains - not supportable
            this.birthdate = payload.birthdate ?
                typeof payload.birthdate === 'string' ?
                luxon.DateTime.fromISO(payload.birthdate).toJSDate() : payload.birthdate instanceof Date ?
                payload.birthdate : payload.birthdate.toDate() : undefined;
            this.loBirthdate = payload.loBirthdate ?
                typeof payload.loBirthdate === 'string' ?
                luxon.DateTime.fromISO(payload.loBirthdate).toJSDate() : payload.loBirthdate instanceof Date ?
                payload.loBirthdate : payload.loBirthdate.toDate() : undefined;

            this.termsAgreedOn = payload.termsAgreedOn ?
                typeof payload.termsAgreedOn === 'string' ?
                luxon.DateTime.fromISO(payload.termsAgreedOn).toJSDate() : payload.termsAgreedOn instanceof Date ?
                payload.termsAgreedOn : payload.termsAgreedOn.toDate() : undefined;

            this.lastLogin = payload.lastLogin ?
                typeof payload.lastLogin === 'string' ?
                luxon.DateTime.fromISO(payload.lastLogin).toJSDate() : payload.lastLogin instanceof Date ?
                payload.lastLogin : payload.lastLogin.toDate() : undefined;

            this.name = payload.name;
            this.zipCode = payload.zipCode;
            this.otherdiagnosis = payload.otherdiagnosis;
            this.loOtherDiagnosis = payload.loOtherDiagnosis;
            this.diagnosis = payload.diagnosis;
            this.loDiagnosis = payload.loDiagnosis;
            this.severity = payload.severity;
            this.travelDistance = payload.travelDistance;
            this.userType = payload.userType;
            this.interests = payload.interests;
            this.avataarUrl = payload.avataarUrl;
            this.gender = payload.gender;
            this.loGender = payload.loGender;
            // this.verified = payload.verified ? payload.verified : false;
            this.imageURL = payload.imageURL;
            this.geohash = payload.geohash;
            this.Reference = payload.Reference;

            if (this.location instanceof GeoPoint) {
                this.location = payload.location;

            } else if (payload.location && payload.location.lat && payload.location.long) {
                this.location = new GeoPoint(payload.location.lat, payload.location.long);
            } else {
                this.location = payload.location;
            }

        } else {
            // this.verified = false;
            this.imageURL = '';
        }
    }

    // ability to set user's document reference
    public setDocumentReference(doc: DocumentReference) {
        this.Reference = doc;
    }

    public toPlainObj(): object {
        if (this.Reference) {
            this.Reference = undefined;
        }

        const ret = JSON.parse(JSON.stringify(this));
        if (ret.location) {
            ret.location = new firebase.firestore.GeoPoint(ret.location._lat, ret.location._long);
        }
        return ret;
    }

    public getAvataarUrl(BASE_URL: string, includeImage: boolean): string {
        const gender = (this.gender && this.gender.toLowerCase() !== 'other') ? this.gender.toLowerCase() : 'male';
        const defaultAvatar = `${BASE_URL}img/default_${gender}_avatar.png`;
        if (this.avataarUrl) {
            return this.avataarUrl;
        } else if (this.imageURL && includeImage) {
            return defaultAvatar;
        } else {
            return defaultAvatar;
        }
    }
    public getUserGender() {
        if (this.gender === 'male') {
            return 'male';
        } else if ( this.gender === 'female') {
            return 'female';
        } else {
            return '';
        }

    }

    public getAge(): string {
        const now = DateTime.local();
        let birthday: DateTime | null = null;
        if (!this.birthdate) {
            return 'No Age Set';
        }
        if (typeof this.birthdate === 'string') {
            birthday = DateTime.fromISO(this.birthdate);
        } else if (this.birthdate instanceof Date) {
            birthday = DateTime.fromJSDate(this.birthdate);
        } else {
            birthday = DateTime.local();
        }
        const diffInYears = now.diff(birthday, 'years').toObject().years;
        return `${diffInYears ? diffInYears.toFixed(0) : 0} Years Old`;
    }
    public getNumericAge(): number {
        const now = DateTime.local();
        let birthday: DateTime | null = null;
        if (!this.birthdate) {
            return 0;
        }
        if (typeof this.birthdate === 'string') {
            birthday = DateTime.fromISO(this.birthdate);
        } else if (this.birthdate instanceof Date) {
            birthday = DateTime.fromJSDate(this.birthdate);
        } else {
            birthday = DateTime.local();
        }
        const diffInYears = now.diff(birthday, 'years').toObject().years;
        return diffInYears ? +diffInYears.toFixed(0) : 0;
    }

    public async getImageUrl(VueInstance: Vue): Promise<string> {
        return new Promise<string>((resolve) => {
            const self = this;
            if (self.uid && self.userUploadedImage) {
                VueInstance.$storage.ref(`user-images/${self.uid}`).getDownloadURL().then( (url) => {
                    resolve(url);
                }, (e: FirebaseError) => {
                    resolve('');
                });
            } else {
                resolve('');
            }
        });
    }

}
// matching  algorithm
export class Comparer {
    public user: MAFUser;
    public friend: MAFUser;
    public totalPossible: number = 21;
    public score: number = 0;
    public matchedInterests: string[] = [];
    constructor(user: MAFUser, friend: MAFUser) {
        this.user = user;
        this.friend = friend;
        this.compare();
    }

    get firstMatchedInterestType() {
        if (this.matchedInterests.length) {
            return this.matchedInterests[0].replace(' ', '');
        }
        return 'general';
    }
    get scoreInPercent(): number {
        return Math.round((this.score / this.totalPossible) * 100);
    }

    public compare() {
        this.matchedInterests = this.similarInterestsAndGroupInterests();
        this.score += this.isWithInAge() ? 3 : 0;
        this.score += this.sameDiagnosis() ? 3 : 0;
        this.score += this.similarSeverity() ? 3 : 0;
        this.score += this.sameGender() ? 3 : 0;
        this.score += this.isWithinFiveMiles() ? 3 : 0;
        this.score += this.matchedInterests.length;

    }

    public isWithInAge(): boolean {
        if (!this.user.birthdate || !this.friend.birthdate) {
            return false;
        }
        let userAge;
        let friendAge;
        const userAgeJS = baseClass.convertToJSDate(this.user.birthdate);
        const friendAgeJS = baseClass.convertToJSDate(this.friend.birthdate);
        if (userAgeJS) {
            userAge = DateTime.fromJSDate(userAgeJS);
        }
        if (friendAgeJS) {
            friendAge = DateTime.fromJSDate(friendAgeJS);
        }
        if (!userAge ||  !friendAge) {
            return false;
        }
        const diffNum = userAge.diff(friendAge, 'year').toObject().years;
        const diff = Math.round(Math.abs( diffNum ? diffNum : 0 ));
        return diff <= 5;
    }

    public sameDiagnosis(): boolean {
        return this.user.diagnosis === this.friend.diagnosis;
    }

    public similarSeverity(): boolean {
        const fSev = this.friend.severity ? this.friend.severity : 0;
        const uSev = this.user.severity ? this.user.severity : 0;
        return Math.abs(fSev - uSev) <= 1;
    }

    public sameGender(): boolean {
        return this.user.gender === this.friend.gender;
    }
    public isWithinFiveMiles(): boolean {
        if (!this.user.location || !this.friend.location) {
            return false;
        }
        const distance = new HaversineFomula(this.user.location, this.friend.location).distance;
        return (distance / 5280) <= 5;

    }
    public similarInterestsAndGroupInterests(): string[] {
        const fi = _.union(this.friend.interests, this.friend.groupInterests);
        const ui = _.union(this.user.interests, this.user.groupInterests);
        return _.intersection(fi, ui);
    }


}

export class PositionObfuscator {

    public static generateRandomPoints(position: Position, radius: number): GeoPoint {
        const u = Math.random();
        const v = Math.random();
        const radiusInDegrees = radius / 111000;

        const w = radiusInDegrees * Math.sqrt(u);
        const t = 2 * Math.PI * v;
        const x = w * Math.cos(t);
        const y = w * Math.sin(t);

        // Adjust the x-coordinate for the shrinking of the east-west distances
        const new_x = x / Math.cos(position.coords.latitude);
        const foundLongitude = new_x + position.coords.longitude;
        const foundLatitude = y + position.coords.latitude;

        return new GeoPoint(foundLatitude, foundLongitude);
    }

    public static generateRandomPointsFromGeopoint(position: GeoPoint, radius: number): GeoPoint {
        const u = Math.random();
        const v = Math.random();
        const radiusInDegrees = radius / 111000;

        const w = radiusInDegrees * Math.sqrt(u);
        const t = 2 * Math.PI * v;
        const x = w * Math.cos(t);
        const y = w * Math.sin(t);

        // Adjust the x-coordinate for the shrinking of the east-west distances
        const new_x = x / Math.cos(position.latitude);
        const foundLongitude = new_x + position.longitude;
        const foundLatitude = y + position.latitude;

        return new GeoPoint(foundLatitude, foundLongitude);
    }
    public longitude: number;
    public latitude: number;

    constructor(lat: number, lng: number) {
        this.longitude = lng;
        this.latitude = lat;
    }

    public obfuscateLocation() {
        // 16093 is ten miles of location
        const u = Math.random();
        const v = Math.random();

        const radiusInDegrees = 16093 / 111000;

        const w = radiusInDegrees * Math.sqrt(u);
        const t = 2 * Math.PI * v;
        const x = w * Math.cos(t);
        const y = w * Math.sin(t);

        // Adjust the x-coordinate for the shrinking of the east-west distances
        const new_x = x / Math.cos(this.latitude);
        const foundLongitude = new_x + this.longitude;
        const foundLatitude = y + this.latitude;
        this.longitude = foundLongitude;
        this.latitude = foundLatitude;

    }
}
